module.exports = __webpack_public_path__ + "static/media/hind-regular.9b6792a6.woff2";